module.exports = __webpack_public_path__ + "static/media/professional-services.d293936c.png";